import type { TranslationKey } from "../locales";

export function getEmailStateTranslationKey(state: string): TranslationKey {
	switch (state) {
		case "bounced":
			return "emails.states.bounced" as TranslationKey;
		case "canceled":
			return "emails.states.canceled" as TranslationKey;
		case "clicked":
			return "emails.states.clicked" as TranslationKey;
		case "complained":
			return "emails.states.complained" as TranslationKey;
		case "delivered":
			return "emails.states.delivered" as TranslationKey;
		case "delivery_delayed":
			return "emails.states.delivery_delayed" as TranslationKey;
		case "failed":
			return "emails.states.failed" as TranslationKey;
		case "opened":
			return "emails.states.opened" as TranslationKey;
		case "queued":
			return "emails.states.queued" as TranslationKey;
		case "scheduled":
			return "emails.states.scheduled" as TranslationKey;
		case "sent":
			return "emails.states.sent" as TranslationKey;
		default:
			return "general.unknown";
	}
}
